import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { countryOptions, titleOptions } from './options';
import Button from '../../components/common/Button';
import FormikControl from '../../components/formik/FormikControl';
// import Debug from '../../components/formik/Debug';

const emptyFormData = {
  // company billing address only
  reciepientTitle: '',
  reciepientFirstName: '',
  reciepientLastName: '',
  companyName: '',
  taxId: '',
  // common
  email: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  countryCode: '',
  additionalInformation: '',
};

const CompanyBillingAddressForm = ({
  initialValues = emptyFormData,
  cancelable,
  onCancel,
  onSubmit,
}) => {
  const validationSchema = Yup.object({
    // company billing address only
    reciepientTitle: Yup.string(),
    reciepientFirstName: Yup.string(),
    reciepientLastName: Yup.string(),
    companyName: Yup.string().required('Company name is required.'),
    taxId: Yup.string(),
    // common
    email: Yup.string().required('Email is required.'),
    addressLine1: Yup.string().required('Address is required.'),
    addressLine2: Yup.string(),
    postalCode: Yup.string().required('Postal code is required.'),
    city: Yup.string().required('City is required.'),
    countryCode: Yup.string().required('Country is required.'),
    additionalInformation: Yup.string(),
  });

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={async (values, onSubmitProps) => {
        values.billingAddressType = 'company';
        await onSubmit(values, onSubmitProps);
        onSubmitProps.setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form className="mt-6 flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <div className="w-full xxxs:w-44">
              <FormikControl
                control="select"
                label="Recipient's Title"
                name="reciepientTitle"
                options={titleOptions}
              />
            </div>

            <FormikControl
              control="input"
              type="text"
              label="Recipient's First Name"
              name="reciepientFirstName"
            />
          </div>

          <div className="flex flex-col gap-4 xxxs:flex-row">
            <FormikControl
              control="input"
              type="text"
              label="Recipient's Last Name"
              name="reciepientLastName"
            />
          </div>

          <FormikControl
            control="input"
            type="email"
            label="Email"
            name="email"
          />

          <div className="flex flex-col gap-4 xxs:flex-row">
            <FormikControl
              control="input"
              type="text"
              label="Address Line 1"
              name="addressLine1"
            />
            <FormikControl
              control="input"
              type="text"
              label="Address Line 2"
              name="addressLine2"
            />
          </div>

          <div className="flex flex-col gap-4 xxs:flex-row">
            <FormikControl
              control="input"
              type="number"
              label="Postal Code"
              name="postalCode"
            />
            <FormikControl
              control="input"
              type="text"
              label="City"
              name="city"
            />
          </div>

          <div className="w-full">
            <FormikControl
              control="select"
              label="Country"
              name="countryCode"
              options={countryOptions}
            />
          </div>

          <div className="flex flex-col gap-4 xxs:flex-row">
            <FormikControl
              control="input"
              type="text"
              label="Company Name"
              name="companyName"
            />

            <FormikControl
              control="input"
              type="text"
              label="VAT-ID"
              name="taxId"
            />
          </div>

          <div className="w-full">
            <FormikControl
              control="input"
              type="text"
              label="Additional Information"
              name="additionalInformation"
            />
          </div>

          <div className="mt-4 flex flex-col gap-4 xxs:flex-row">
            <Button
              variant="primary"
              text={cancelable ? 'Save' : 'Continue'}
              type="submit"
              onClick={() => {}}
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            />

            {!formik.isSubmitting && cancelable && (
              <Button
                variant="transparent"
                text="Cancel"
                onClick={() => onCancel()}
              />
            )}
          </div>
          {/* <div className="fixed top-0 right-0"><Debug /></div> */}
        </Form>
      )}
    </Formik>
  );
};

CompanyBillingAddressForm.propTypes = {
  initialValues: PropTypes.shape({
    // company billing address only
    reciepientTitle: PropTypes.string,
    reciepientFirstName: PropTypes.string,
    reciepientLastName: PropTypes.string,
    companyName: PropTypes.string,
    taxId: PropTypes.string,
    // common
    email: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    postalCode: PropTypes.string,
    city: PropTypes.string,
    countryCode: PropTypes.string,
    additionalInformation: PropTypes.string,
  }),
  cancelable: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default CompanyBillingAddressForm;
